"use strict";

document.addEventListener('click', (e) => {
    const btn = e.target.closest('.btn-toggle-password-visibility');
    if (!btn) return;

    const group = btn.closest('.input-group');
    const input = group ? group.querySelector('.form-control') : null;
    if (!input || typeof input.type === 'undefined') return;

    input.type = (input.type === 'password') ? 'text' : 'password';
    btn.setAttribute('aria-pressed', String(input.type === 'text'));
});



// Utils --------------------------------------------------------------

/**
 * Applica/rimuove le classi Bootstrap di validità a un singolo campo.
 * Supporta input/select/textarea, checkbox/radio e gruppi.
 */
function setValidityClasses(field, isValid) {
    // Campo "base" su cui applicare le classi (per i checkbox/radio usa l'input stesso)
    const target = field.classList.contains('form-control') || field.classList.contains('form-select')
        ? field
        : field; // fallback

    target.classList.toggle('is-valid', isValid);
    target.classList.toggle('is-invalid', !isValid);

    // Messaggi di errore: usa <div class="invalid-feedback"> vicino al campo, se presente
    const feedback =
        document.getElementById(field.getAttribute('aria-describedby')?.split(' ').find(id => id?.includes('Feedback'))) ||
        field.closest('.mb-3')?.querySelector('.invalid-feedback') ||
        field.parentElement?.querySelector('.invalid-feedback');

    if (feedback) {
        feedback.textContent = getErrorMessage(field);
    }
}

/**
 * Costruisce un messaggio di errore leggibile in base alla ValidityState del campo.
 * Se vuoi messaggi custom per un singolo campo, usa field.dataset.msgRequired, ecc.
 */
function getErrorMessage(field) {
    const v = field.validity;

    if (field.validationMessage && !field.dataset.msgAuto) {
        // Il browser ha già un messaggio: puoi forzare il tuo via setCustomValidity oppure usare dataset
        return field.validationMessage;
    }

    if (v.valueMissing)   return field.dataset.msgRequired     || 'Questo campo è obbligatorio.';
    if (v.typeMismatch)   return field.dataset.msgType         || 'Il formato non è valido.';
    if (v.tooShort)       return field.dataset.msgTooShort     || `Troppo corto (min ${field.minLength} caratteri).`;
    if (v.tooLong)        return field.dataset.msgTooLong      || `Troppo lungo (max ${field.maxLength} caratteri).`;
    if (v.patternMismatch)return field.dataset.msgPattern      || 'Il valore non rispetta il pattern richiesto.';
    if (v.rangeUnderflow) return field.dataset.msgUnderflow    || `Il valore deve essere ≥ ${field.min}.`;
    if (v.rangeOverflow)  return field.dataset.msgOverflow     || `Il valore deve essere ≤ ${field.max}.`;
    if (v.stepMismatch)   return field.dataset.msgStep         || 'Il valore non rispetta lo step.';
    if (v.badInput)       return field.dataset.msgBadInput     || 'Inserisci un valore valido.';
    if (v.customError)    return field.validationMessage; // già settato via setCustomValidity

    return ''; // nessun errore
}

/**
 * Valida un singolo campo con le API native e aggiorna le classi Bootstrap.
 */
function validateField(field) {
    field.setCustomValidity('');

    // Regola custom: password e conferma devono coincidere
    if (field.name === 'pwd' || field.name === 'pwd_confirm') {
        const form = field.form;
        const p  = form.querySelector('input[name="pwd"]');
        const pc = form.querySelector('input[name="pwd_confirm"]');
        if (p && pc && p.value && pc.value && p.value !== pc.value) {
            // imposta l'errore su entrambi così evidenzi entrambi
            p.setCustomValidity('Le password non coincidono.');
            pc.setCustomValidity('Le password non coincidono.');
        } else {
            p && p.setCustomValidity('');
            pc && pc.setCustomValidity('');
        }
    }

    const isValid = field.checkValidity();
    setValidityClasses(field, isValid);
    return isValid;
}

/**
 * Valida tutti i campi controllabili del form (anche gruppi di checkbox/radio).
 */
function validateForm(form) {
    const fields = Array.from(form.querySelectorAll('input, select, textarea'))
        .filter(el => !el.disabled && el.willValidate !== false);

    let allValid = true;

    for (const field of fields) {
        // Gestione gruppi radio/checkbox: se required, almeno uno selezionato
        if ((field.type === 'radio' || field.type === 'checkbox') && field.required) {
            const group = form.querySelectorAll(`input[name="${field.name}"]`);
            const oneChecked = Array.from(group).some(i => i.checked);
            group.forEach(i => {
                if (!oneChecked) {
                    i.setCustomValidity('Seleziona almeno un\'opzione.');
                } else {
                    i.setCustomValidity('');
                }
                setValidityClasses(i, i.checkValidity());
            });
            if (!oneChecked) allValid = false;
            continue;
        }

        const ok = validateField(field);
        if (!ok) allValid = false;
    }

    return allValid;
}

// Wiring -------------------------------------------------------------
(function () {

    function setupForm(form) {
        form.addEventListener('input', onLiveValidate, true);
        form.addEventListener('change', onLiveValidate, true);
        form.addEventListener('blur', onLiveValidate, true);
        form.addEventListener('submit', onSubmit);
    }

    function onLiveValidate(e) {
        const field = e.target;
        if (!(field instanceof HTMLInputElement || field instanceof HTMLTextAreaElement || field instanceof HTMLSelectElement)) {
            return;
        }
        // Valida solo se il campo sta dentro a un form che gestiamo
        const form = field.closest('form.needs-validation');
        if (!form) return;

        field.dataset.touched = 'true';
        validateField(field);
    }

    function onSubmit(e) {
        const form = e.currentTarget;
        // Segna tutto come "toccato"
        form.querySelectorAll('input, select, textarea').forEach(el => el.dataset.touched = 'true');

        const ok = validateForm(form);
        form.classList.add('was-validated');

        if (!ok) {
            e.preventDefault();
            e.stopPropagation();
            const firstInvalid = form.querySelector('.is-invalid');
            if (firstInvalid && firstInvalid.focus) firstInvalid.focus();
        }
    }

    // Inizializza tutti i form presenti
    document.querySelectorAll('form.needs-validation').forEach(setupForm);

    // (Opzionale) Inizializza anche form inseriti dinamicamente (modal/AJAX)
    const mo = new MutationObserver((mutations) => {
        mutations.forEach(m => {
            m.addedNodes.forEach(node => {
                if (!(node instanceof HTMLElement)) return;
                if (node.matches && node.matches('form.needs-validation')) setupForm(node);
                node.querySelectorAll && node.querySelectorAll('form.needs-validation').forEach(setupForm);
            });
        });
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });

})();
